import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-session-popup',
    templateUrl: './session-popup.component.html',
    styleUrls: ['./session-popup.component.sass'],
    standalone: false
})

/**
 * This is how you call it 
 * popupService.openDialog(SessionPopupComponent, {
                  data : {message: "hello"}
                })
 */
export class SessionPopupComponent {

  message = '';

  constructor(private dialogRef: MatDialogRef<SessionPopupComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { message: string }) { 
    if(data && data.message) {
      this.message = data.message;
    }
  }

  closeDialog(status: string): void {
    this.dialogRef.close(status);
  }

}